import { AnyAction } from 'redux'

import { TOGGLE_EDIT_VENDOR_PRICING_AGREEMENT_MODAL } from '@actions/ui/editVendorPricingAgreement'

const initialEditVendorPricingAgreementModalState = { show: false }

export const editVendorPricingAgreementModal = (
  state = initialEditVendorPricingAgreementModalState,
  action: AnyAction,
) => {
  switch (action.type) {
    case TOGGLE_EDIT_VENDOR_PRICING_AGREEMENT_MODAL:
      return { ...state, show: action.show }
    default:
      return state
  }
}
